<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  created() {},
  mounted() {},
};
</script>

<style lang="scss">
@import "colorui/animation.css";
@import "colorui/main.scss";
@import "colorui/element.scss";
@import "colorui/project.css";
@import "colorui/common.scss";

* {
  font-family: "roboto", normal;
  margin: 0;
  padding: 0;
  font-size: 14px;
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  margin: 0;
  height: 100%;
}

#app {
  height: 100%;
}

a {
  text-decoration: none;
  color: inherit;
}
.el-dropdown-menu {
  padding: 10px !important;
}
</style>
